/**
 * Reviews.io rating counters on the PDP and on product lists.
 *
 * The rating snippet (stars + "(N Reviews)") loads totals from
 * /product/rating-batch. That endpoint returns an empty list for this
 * store, so every snippet paints 0. The review list uses /timeline/data,
 * which has the real aggregate. This writes that total into each snippet.
 */
(function () {
  if (window.__pdpRatingCountBound) return;
  window.__pdpRatingCountBound = true;

  const STORE = 'www.sunfood.com';
  const SELECTOR = '.ruk_rating_snippet';
  const MAX_IN_FLIGHT = 4;

  const queue = [];
  let inFlight = 0;

  function stars(rating) {
    const rounded = Math.round(rating * 2) / 2;
    let html = '';
    for (let i = 1; i <= 5; i += 1) {
      let pct = 0;
      if (rounded >= i) pct = 100;
      else if (rounded >= i - 0.5) pct = 50;
      html += '<i aria-hidden="true" class="ruk-icon-percentage-star--' + pct + '"></i>';
    }
    return html;
  }

  function labelFor(count) {
    return count === 1 ? 'Review' : 'Reviews';
  }

  function shownCount(el) {
    const span = el.querySelector('.ruk-rating-snippet-count');
    if (!span) return null;
    const match = span.textContent.match(/\((\d+)/);
    return match ? Number(match[1]) : null;
  }

  function paint(el, rating, count) {
    const label = labelFor(count);
    const average = Math.round(rating * 100) / 100;
    const title = average + ' - ' + count + ' ' + label;
    el.innerHTML =
      stars(rating) +
      '<br>' +
      '<span aria-hidden="true" class="ruk-rating-snippet-count" style="color:#333333">(' +
      count +
      ' ' +
      label +
      ')</span>';
    el.setAttribute('title', title);
    el.setAttribute('aria-label', title);
  }

  function fetchStats(sku) {
    const params = new URLSearchParams({
      type: 'product_review',
      store: STORE,
      sort: 'date_desc',
      page: '1',
      per_page: '1',
      sku: sku
    });
    return fetch('https://api.reviews.io/timeline/data?' + params.toString(), {
      headers: { accept: 'application/json' }
    }).then(function (res) {
      if (!res.ok) return null;
      return res.json();
    }).then(function (data) {
      const stats = data && data.stats;
      const count = Number(stats && stats.review_count);
      const rating = Number(stats && stats.average_rating);
      if (!Number.isFinite(count) || count < 1 || !Number.isFinite(rating)) return null;
      return { count: count, rating: rating };
    });
  }

  function pump() {
    while (inFlight < MAX_IN_FLIGHT && queue.length) {
      const job = queue.shift();
      inFlight += 1;
      fetchStats(job.sku).then(function (result) {
        job.stats = result;
        job.apply();
      }).catch(function () {}).then(function () {
        inFlight -= 1;
        pump();
      });
    }
  }

  function bind(el) {
    if (!el || el.dataset.pdpRatingBound === 'true') return;
    const sku = el.getAttribute('data-sku') || '';
    if (!sku) return;
    el.dataset.pdpRatingBound = 'true';

    let painting = false;
    const job = { sku: sku, stats: null, apply: apply };

    function apply() {
      if (!job.stats || painting) return;
      if (shownCount(el) === job.stats.count) return;
      painting = true;
      paint(el, job.stats.rating, job.stats.count);
      painting = false;
    }

    const observer = new MutationObserver(function () {
      apply();
    });
    observer.observe(el, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-label']
    });

    queue.push(job);
    pump();
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(SELECTOR).forEach(bind);
    if (root.matches && root.matches(SELECTOR)) bind(root);
  }

  function start() {
    scan(document);
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) scan(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
